export default {

    // mixins: [BaseForm],
    // inject: [$store],
    // props: ['value'],

    mounted() {
        console.log('####### mounted: team-list.vue');
        // console.warn(this.value);

        // console.warn(this.$store.state.members_active);
        // this.$store = this.store
        for (var i = 0; i < this.members_num; i++) {
            // this.$store.commit('setCollapsed', i)
            this.members_active[i] = false;
        }
        // this.$emit('input', this.members_active);
        // console.warn(this.members_active);
    },
    computed: {

    },
    watch: {
        //
        // 'members_active': {
        //
        //     handler: function(val){
        //         alert('ddd');
        //     },
        //     deep: true
        // }

    },
    methods: {
        // expanded(index) {
        //      console.warn('is_expanded|'+index);
        //     // return this.global_members_active[index]
        //     if (index == this.members_active) {
        //         return true
        //     } else {
        //         return false
        //     }
        // },
        closeclick() {
            console.log('_CLOSECLICK');
            for (var i = 0; i < this.members_num; i++) {
                this.members_active[i] = false;
                this.member_active = false;
            }
            this.profilewindow_open = false;
            this.$forceUpdate();
        },
        click(member) {
            if (!this.profilewindow_open || this.member_active != member) {
                console.log('_CLICKED '+member);
                // console.warn(this.members_active[member]);
                // for (var i = 0; i < this.members_num; i++) {
                //     this.$store.commit('setCollapsed', i)
                //
                // }
                // this.$store.commit('setExpanded', member  );
                // // console.warn(this.$store.state.members_active);
                //
                // this.$store.dispatch('setExpanded', member);
                // console.warn(this.$store.state.members_active);

                // this.$nextTick(() => {
                for (var i = 0; i < this.members_num; i++) {
                    this.members_active[i] = false;
                }
                this.members_active[member] = !this.members_active[member];
                this.member_active = member;
                this.profilewindow_open = true;
                // this.$root.member_selected = member;
                // var that = this;
                // this.$emit('input', member);
                // });
                this.$forceUpdate();
            }
        }



    },
    data: function() {
        return {
            members_num: 7,
            members_active: [],
            member_active: false,
            profilewindow_open: false,
            // expanded: false,
            // cities: [],
            isLoading: false,
            options: [ ],
            success: '',
            error: '',
            form: {
                csrf: '',
                uid: null,

            }
        }
    }
}
